/**
 * @name: 数据统计-商品销售明细接口文件
 * @author: itmobai
 * @date: 2023-12-07 16:39
 * @description： 数据统计-商品销售明细接口文件
 * @update: 2023-12-07 16:39
 */
import {get, postJ} from "@/request"
import {IPageRes} from "@/apis/page";
import {ISaleDetailParam, ISaleDetailRes} from "@/apis/statistics/saleDetail/types";

/**
 * 分页查询
 * @param params
 */
export const queryProductSaleByPageApi = (params: ISaleDetailParam) => get<ISaleDetailRes>("/card/data/statistics/queryProductSaleByPage", params)
/**
 * 导出
 * @param params
 */
export const productSaleExportApi = (params: ISaleDetailParam) => get("/card/data/statistics/productSaleExport", params, "blob")
